// =====================================================================
// retourApresLogin.js — revenir à la page demandée après la connexion
// =====================================================================
// Un téléphone non connecté qui scanne l'autocollant d'une trousse arrive sur
// /accidents?scan=BS-01, est renvoyé vers /login… et, avant le 23-10-2026,
// atterrissait ensuite sur l'accueil : le code scanné était perdu.
// Seul un chemin INTERNE est accepté (pas « //autre-site », pas une adresse
// complète) : la page de connexion ne doit jamais servir de redirection ouverte.
// =====================================================================

/** La page à retrouver après la connexion : dans l'état de navigation, ou dans ?retour= (redirection « dure » sur 401). */
export function retourDe(location) {
  return cheminRetour(location?.state?.retour) || cheminRetour(new URLSearchParams(location?.search || '').get('retour'));
}

export function cheminRetour(chemin) {
  const p = typeof chemin === 'string' ? chemin.trim() : '';
  if (!p || p.length > 500) return null;
  if (!p.startsWith('/') || p.startsWith('//') || p.startsWith('/\\')) return null;
  if (/[\u0000-\u001f]/.test(p)) return null;
  if (p === '/' || p.startsWith('/login')) return null;
  return p;
}
